import { capitalize } from 'Data/format.js'

export function getText(status) {
  return status
    .split('_')
    .map(el => capitalize(el))
    .join(' ')
}

export function getColor(statusType) {
  switch (statusType) {
    case 'grey': {
      return '#E4E7EB'
    }
    case 'blue': {
      return '#D1EEFC'
    }
    case 'orange': {
      return '#FFEACC'
    }
    case 'green': {
      return '#C1EAC5'
    }
    case 'red': {
      return '#FACDCD'
    }
    default: {
      return '#CBD2D9'
    }
  }
}
